import { ResolveAiFieldProposalInput } from "src/generated/graphqlTypes";
import { ObjectConfig } from "src/utils/formState";
import { type AiFormAfpFragment } from "./aiProposalForm.generated";

export type AiFieldProposalFormValue = ResolveAiFieldProposalInput &
  Pick<AiFormAfpFragment, "fieldName" | "fieldValue" | "parentType" | "pageNumbers"> & {
    /** The document `pageNumbers` are pages of, i.e. the proposal's `asset.downloadUrl`. */
    sourceUrl?: string;
  };

/** Nest as `fieldProposals: { type: "list", update: "incremental", config: aiFieldProposalConfig }` on a form that reviews AI field proposals. `fieldName`/`fieldValue` are server-owned; `status` is what Accept/Reject writes. */
export const aiFieldProposalConfig: ObjectConfig<AiFieldProposalFormValue> = {
  id: { type: "value" },
  fieldName: { type: "value", readOnly: true },
  fieldValue: { type: "value", readOnly: true },
  // parentType is readOnly server metadata that identifies CREATE/DELETE proposals.
  parentType: { type: "value", readOnly: true },
  // Both are readOnly and back the field's `Sources:` links; sourceUrl comes from the parent proposal.
  pageNumbers: { type: "value", readOnly: true },
  sourceUrl: { type: "value", readOnly: true },
  status: { type: "value" },
};
